import {ChartCard} from '@github-ui/chart-card'
import type {CommitMetricDataPoints} from '../types'

export type CommitActivityChartProps = {
  commits: CommitMetricDataPoints[]
}

export default function CommitActivity({commits}: CommitActivityChartProps) {
  return (
    <>
      <ChartCard size="xl" border padding="normal" visibleControls>
        <ChartCard.Title as="h2">Commits</ChartCard.Title>
        <ChartCard.Description>Number of commits per week</ChartCard.Description>
        <ChartCard.ColumnChart
          options={{
            yAxis: {
              title: 'Commits',
            },
            xAxis: {
              type: 'datetime',
              gridLineWidth: 0,
              labels: {
                format: '{value:%b}',
              },
              tickInterval: 30 * 24 * 60 * 60 * 1000, // Monthly intervals (30 days in milliseconds)
              minorTickInterval: 7 * 24 * 60 * 60 * 1000, // Weekly minor ticks
              minorTickLength: 0,
              minorGridLineWidth: 0,
            },
            plot: {
              animation: false,
            },
          }}
          overrideOptionsNotRecommended={{
            plotOptions: {
              column: {
                pointPadding: 0.05,
                borderWidth: 0,
                groupPadding: 0.02,
              },
            },
            tooltip: {
              xDateFormat: 'Week of %e %b, %Y',
              split: false,
            },
          }}
          colors={['green']}
          series={[
            {
              name: 'Commits',
              data: commits,
            },
          ]}
        />
      </ChartCard>
    </>
  )
}

try{ CommitActivity.displayName ||= 'CommitActivity' } catch {}